export const failCheckTableColumns = [
  //   {
  //     key: "type",
  //     display_name: "Type",
  //     cellStyles: {
  //       "font-size": "13px",
  //     },
  //     headerStyles: {
  //       background: "#7593F2",
  //       "font-weight": "600",
  //       width: "25%",
  //       borderRadius: "6px 0 0",
  //       color: "#fff",
  //     },
  //     _config: {
  //       type: "image",
  //       displayInColumn: false,
  //       isCondional: true,
  //       targetKey: "status",
  //       value: {
  //         fail: {
  //           value: "../../../../assets/images/virtusa-icons/fail.svg",
  //         },
  //         pass: {
  //           value: "../../../../assets/images/virtusa-icons/pass.svg",
  //         },
  //       },
  //     },
  //   },
  {
    key: "status",
    display_name: "Type",
    cellStyles: {
      "font-size": "13px",
    },
    headerStyles: {
      background: "#EBEAEA",
      width: "5%",
      color: "#fff",
    },
    _config: {
      type: "svg",
      displayInColumn: false,
      value: "../../../../assets/images/virtusa-icons/fail-check.svg",
    },
  },
  {
    display_name: "",
    key: "type",
    headerStyles: {
      color: "#ffffff",
      background: "#EBEAEA",
      width: "15%",
    },
  },
  {
    display_name: "Severity",
    key: "severity",
    headerStyles: {
      color: "#ffffff",
      background: "#EBEAEA",
      width: "15%",
    },
    _config: {
      type: "lozenge",
      classMapping: {
        Showstopper: "severity-card showstopper-severity",
        Medium: "severity-card medium-severity",
        High: "severity-card high-severity",
        Low: "severity-card low-severity",
        default: "severity-card deafult",
      },
    },
  },
  {
    display_name: "Description",
    key: "negativeDescription",
    headerStyles: {
      background: "#EBEAEA",
      width: "25%",
    },
  },
  {
    display_name: "Suggested Fix",
    key: "suggestedFix",
    headerStyles: {
      width: "40%",
      background: "#EBEAEA",
    },
  },
];

export const failCheckDummyData = [
  {
    type: "Ambiguous words/adjectives​",
    status: "fail",
    severity: "medium",
    description: "Successful addition is vague — what defines successful",
    suggestion:
      "Rephrase as Upon persisting a new production the system database",
  },
  {
    type: "Completeness of rules/conditional statements ​",
    status: "fail",
    severity: "high",
    description:
      "No validation rules or formats are specified for fields like SKU or category.​",
    suggestion:
      "For SKU reference format of SKU ID, for category indicate how values should be selected etc.​​",
  },
];
